import React, { useEffect, useState, useContext } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
// import { getCurrentUser } from "../Helper";
import { AuthContext } from "../Auth/Auth";
import Spinner from "../Spinner/Spinner";

const ProtectedRoutesComponent = () => {
  const location = useLocation();
  const { currentUser } = useContext(AuthContext);
  const [studentDetails, setStudentDetails] = useState(null);
  const fieldsToValidate = [
    "contact_number",
    "availability",
    "onsite_availability",
    "city",
    "preferred_city",
    "current_salary",
    "expected_salary",
    "state",
    "college",
    "degree",
    "passing_year",
    "key_skills",
    "career_interest",
  ];

  const isValidUserData = (userData) => {
    if (!userData?.email) return false;
    return !fieldsToValidate.some(
      (key) =>
        userData?.[key] === undefined ||
        userData?.[key] === null ||
        userData?.[key] === ""
    );
  };

  // If no Firebase user, redirect to home
  if (!currentUser) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // If Firebase user exists, render the protected route
  return <Outlet />;
};

export default ProtectedRoutesComponent;
